import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import { OpeningHours } from 'lib-shared-types-api';

import { ListItemHeader } from '../listItemHeader/listItemHeader';

import styles from './dateCard.module.scss';

type Props = {
  exception: OpeningHours;
  isSelected: boolean;
  onClick: VoidFunction;
};

export const DateCard = ({
  exception,
  isSelected,
  onClick,
}: Props): JSX.Element => (
  <div
    className={classNames(styles.root, {
      [styles.rootIsOverridden]: !!exception.overridden_by,
      [styles.rootIsSelected]: isSelected,
    })}
    onClick={onClick}
  >
    <ListItemHeader
      duration={exception.duration}
      name={exception.name}
      nextDate={exception.next_date}
      openingHourType={exception.opening_hour_type}
      recurring={exception.recurring}
    />
    <FlexBox alignItems="center" padding="0 200 0">
      <Text.Paragraph className={styles.intervalsText}>
        {exception.intervals?.length
          ? exception.intervals
              .map(({ start, end }) => `${start} - ${end}`)
              .join(', ')
          : 'Closed'}
      </Text.Paragraph>
    </FlexBox>
    <div className={styles.selectText}>
      {isSelected && <Icon color={colors.purple[600]} name="done" />}
      <Text.Paragraph
        variant="3"
        {...(isSelected && { color: colors.purple[600] })}
      >
        {isSelected ? 'Selected' : 'Click to select'}
      </Text.Paragraph>
    </div>
  </div>
);
